import React from 'react';

function TechPill({ tech }) {
  return (
    <span className="tech-pill">
      {tech}
    </span>
  );
}

export default TechPill; 